import { reactive } from 'vue';
import axios from 'axios';

const getInt = (val, fallback) => val ? parseInt(val, 10) : fallback;
const getBool = (val, fallback) => val !== undefined ? (val === 'true' || val === true) : fallback;

export const config = reactive({
    allowVideoToggle: false,
    showQueueBalance: true,
    /**
     * Fallback-STUN-URL, wenn vom Server kein rtcConfig im CALL_START mitgeliefert wird.
     * Die primäre STUN-Server-Liste kommt als stunServers-Array aus /api/config
     * und wird vom MatchMaker im CALL_START-Payload als data.rtcConfig gesendet.
     */
    stunFallbackServerUrl: 'stun:stun.l.google.com:19302',
    /**
     * Primäre STUN-Server als Array (aus STUN_SERVERS_JSON in .env).
     * Vom Backend via /api/config geliefert, Debug-Zweck.
     * Tatsächlich verwendet wird der Wert aus data.rtcConfig (CALL_START).
     */
    stunServers: null,
    pollingInterval: 3000,
    balanceIntervalIdle: 60000,
    balanceIntervalActive: 1000,
    defaultCallDuration: 100,
    allowThemeSwitch: false,
    // Audio-Pipeline (Browser-Defaults bis /config geladen ist)
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    opusMunging: false,
    adminUuid: '',
    enableEmail: false,
    enableChargebackOverview: false,
    activeTheme: 'velvet',
    meta: {
        appName: 'Telesex',
        appTitle: 'Live Chat',
        favicon: '/branding/favicon.ico',
        logoUrl: '/branding/logo.png'
    },
    apiBaseUrl: window.location.origin,
    wsUrl: `${window.location.protocol === 'https:' ? 'wss://' : 'ws://'}${window.location.host}`
});

let configPollInterval = null;
const CONFIG_POLL_INTERVAL_MS = 30000;

export async function loadConfig() {
    try {
        const response = await axios.get(`${config.apiBaseUrl}/api/config`);

        if (response.data) {
            const s = response.data;

            config.allowVideoToggle = getBool(s.allowVideoToggle, config.allowVideoToggle);
            config.showQueueBalance = getBool(s.showQueueBalance, config.showQueueBalance);
            config.allowThemeSwitch = getBool(s.allowThemeSwitch, config.allowThemeSwitch);
            config.echoCancellation = getBool(s.echoCancellation, config.echoCancellation);
            config.noiseSuppression = getBool(s.noiseSuppression, config.noiseSuppression);
            config.autoGainControl = getBool(s.autoGainControl, config.autoGainControl);
            config.opusMunging = getBool(s.opusMunging, config.opusMunging);
            config.stunFallbackServerUrl = s.stunFallbackServerUrl || config.stunFallbackServerUrl;
            config.stunServers = Array.isArray(s.stunServers) ? s.stunServers : config.stunServers;
            config.pollingInterval = getInt(s.pollingInterval, config.pollingInterval);
            config.balanceIntervalIdle = getInt(s.balanceIntervalIdle, config.balanceIntervalIdle);
            config.balanceIntervalActive = getInt(s.balanceIntervalActive, config.balanceIntervalActive);
            config.defaultCallDuration = getInt(s.defaultCallDuration, config.defaultCallDuration);
            config.adminUuid = s.adminUuid || '';
            config.enableEmail = getBool(s.enableEmail, config.enableEmail);
            config.enableChargebackOverview = getBool(s.enableChargebackOverview, config.enableChargebackOverview);

            if (s.appName) config.meta.appName = s.appName;
            if (s.appTitle) config.meta.appTitle = s.appTitle;
            if (s.favicon) config.meta.favicon = s.favicon;
            if (s.logoUrl) config.meta.logoUrl = s.logoUrl;

            // DON'T overwrite apiBaseUrl - keep using relative paths for proxy!
            // The proxy handles /api -> backend:3000
            // config.apiBaseUrl = s.apiBaseUrl || config.apiBaseUrl;

            // WebSocket: use relative path to go through proxy
            // config.wsUrl = s.wsUrl;
        }

        const themeRes = await axios.get(`${config.apiBaseUrl}/api/themes/active`);
        if (themeRes.data?.theme) {
            config.activeTheme = themeRes.data.theme;
        }

    } catch (e) {
        console.error("Config load error:", e.message);
    }
}

export function startConfigPolling() {
    if (configPollInterval) return;
    configPollInterval = setInterval(loadConfig, CONFIG_POLL_INTERVAL_MS);
}

export function stopConfigPolling() {
    if (configPollInterval) {
        clearInterval(configPollInterval);
        configPollInterval = null;
    }
}
